/**
 * Sidebar navigation. Icons are inline stroke SVGs — the Tessera line-icon
 * language (no filled icon fonts, never emoji).
 */

const NavIcon = ({ children }) => (
    <svg
        width={18}
        height={18}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {children}
    </svg>
);

const ICONS = {
    dashboard: (
        <NavIcon>
            <rect x="3" y="3" width="7" height="9" rx="1" />
            <rect x="14" y="3" width="7" height="5" rx="1" />
            <rect x="14" y="12" width="7" height="9" rx="1" />
            <rect x="3" y="16" width="7" height="5" rx="1" />
        </NavIcon>
    ),
    profile: (
        <NavIcon>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </NavIcon>
    ),
    users: (
        <NavIcon>
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
        </NavIcon>
    ),
    roles: (
        <NavIcon>
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            <path d="M9 12l2 2 4-4" />
        </NavIcon>
    ),
    objects: (
        <NavIcon>
            <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
            <path d="M3.3 7 12 12l8.7-5M12 22V12" />
        </NavIcon>
    ),
    workflows: (
        <NavIcon>
            <circle cx="6" cy="6" r="3" />
            <circle cx="18" cy="18" r="3" />
            <path d="M6 9v3a4 4 0 0 0 4 4h5" />
            <path d="M13 13l3 3-3 3" />
        </NavIcon>
    ),
    apiKeys: (
        <NavIcon>
            <circle cx="7.5" cy="15.5" r="4.5" />
            <path d="M10.85 12.15 19 4M18 5l3 3M15 8l2 2" />
        </NavIcon>
    ),
    apiDocs: (
        <NavIcon>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6" />
            <path d="M10 12.5 8 15l2 2.5M14 12.5 16 15l-2 2.5" />
        </NavIcon>
    ),
    webhooks: (
        <NavIcon>
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
        </NavIcon>
    ),
    audit: (
        <NavIcon>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <path d="M14 2v6h6M8 13h8M8 17h5" />
        </NavIcon>
    ),
};

export const GENERAL_OPTIONS = [
    { label: "Dashboard", icon: ICONS.dashboard, path: "/dashboard" },
    { label: "My Profile", icon: ICONS.profile, path: "/profile" },
];

export const ADMIN_OPTIONS = [
    { label: "Users", icon: ICONS.users, path: "/admin/users" },
    { label: "Roles", icon: ICONS.roles, path: "/admin/roles" },
    { label: "Objects", icon: ICONS.objects, path: "/admin/objects" },
    { label: "Workflows", icon: ICONS.workflows, path: "/admin/workflows" },
    { label: "API Keys", icon: ICONS.apiKeys, path: "/admin/api-keys" },
    { label: "API Docs", icon: ICONS.apiDocs, path: "/admin/api-docs" },
    { label: "Webhooks", icon: ICONS.webhooks, path: "/admin/webhooks" },
    { label: "Audit Log", icon: ICONS.audit, path: "/admin/audit" },
];
